"use strict";
/**
 * Award rate mapping structure for Australian healthcare shift types.
 *
 * These rates are used by the Audit Engine to calculate expected pay
 * for each shift based on the shift type. Rates are expressed as
 * AUD per hour.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_SHIFT_TYPES = exports.DEFAULT_AWARD_RATES = void 0;
exports.getHourlyRate = getHourlyRate;
/**
 * Default award rates for Australian healthcare workers.
 * These serve as baseline rates and should be configurable per deployment.
 *
 * Rates are indicative and based on the Health Professionals and Support
 * Services Award (MA000027). Actual rates vary by classification level.
 */
exports.DEFAULT_AWARD_RATES = {
    ordinary: {
        shiftType: 'ordinary',
        description: 'Standard weekday hours (Mon-Fri, 06:00-18:00)',
        hourlyRateAud: 38.00,
    },
    overtime: {
        shiftType: 'overtime',
        description: 'Hours beyond standard shift or 38 hours/week',
        hourlyRateAud: 57.00,
    },
    night_shift: {
        shiftType: 'night_shift',
        description: 'Night shift hours (typically 18:00-06:00)',
        hourlyRateAud: 45.60,
    },
    weekend: {
        shiftType: 'weekend',
        description: 'Saturday and Sunday shifts',
        hourlyRateAud: 57.00,
    },
    public_holiday: {
        shiftType: 'public_holiday',
        description: 'Gazetted public holiday shifts',
        hourlyRateAud: 76.00,
    },
};
/**
 * Retrieves the hourly rate for a given shift type from a rate map.
 * Returns the rate in AUD.
 */
function getHourlyRate(shiftType, rates = exports.DEFAULT_AWARD_RATES) {
    return rates[shiftType].hourlyRateAud;
}
/**
 * All valid shift types as an array (useful for validation and generators).
 */
exports.ALL_SHIFT_TYPES = [
    'ordinary',
    'overtime',
    'night_shift',
    'weekend',
    'public_holiday',
];
//# sourceMappingURL=award-rates.js.map